import React from 'react';
import { motion } from 'framer-motion';
import { FaTwitter, FaTelegram, FaGithub, FaMedium, FaChevronUp } from 'react-icons/fa';
import './MainContent.css';

const Footer = () => {
  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <footer className="footer">
      <div className="footer-top">
        <button className="scroll-top-button" onClick={scrollToTop} aria-label="Scroll to top">
          <FaChevronUp />
        </button>
      </div>
      
      <div className="footer-content">
        <div className="footer-logo-section">
          <div className="footer-logo-container">
            <img 
              src="/Untitled-3.png" 
              alt="WiggaChain Logo" 
              className="footer-logo-image" 
            />
            <h2 className="footer-logo">WiggaChain</h2>
          </div>
          <p className="footer-tagline">Building the financial future one block at a time</p>
          
          <div className="footer-social">
            <a href="https://twitter.com/wiggachainonSolana" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="https://t.me/wiggachainportal" target="_blank" rel="noopener noreferrer" aria-label="Telegram">
              <FaTelegram />
            </a>
          </div>
        </div>
        
        <div className="footer-links">
          <div className="footer-column">
            <h3 className="footer-column-title">Product</h3>
            <a href="#features">Features</a>
            <a href="#about">About</a>
            <a href="#how-to-buy">How to Buy</a>
            <a href="#roadmap">Roadmap</a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-container">
          <p className="copyright">© 2025 WiggaChain. All rights reserved.</p>
          <p className="disclaimer">
            Disclaimer: This is a parody website for demonstration purposes. Not a real financial product.
          </p>
        </div>
      </div>
      
      <div className="footer-background">
        <div className="cyber-grid footer-grid"></div>
      </div>
    </footer>
  );
};

export default Footer;